export const ENTRY_ATTEMPT_PREFIX = 'salesbreaker:uiux-entry-attempt:';

export const getUiSurfaceEntryAttemptKey = (releaseId, userId) => (
  `${ENTRY_ATTEMPT_PREFIX}${releaseId}:${userId}`
);

export const hasUiSurfaceEntryAttempt = (storage, releaseId, userId) => {
  try {
    return storage?.getItem?.(getUiSurfaceEntryAttemptKey(releaseId, userId)) === 'attempted';
  } catch (_error) {
    return true;
  }
};

export const markUiSurfaceEntryAttempt = (storage, releaseId, userId) => {
  try {
    storage?.setItem?.(getUiSurfaceEntryAttemptKey(releaseId, userId), 'attempted');
    return true;
  } catch (_error) {
    return false;
  }
};

export const clearUiSurfaceEntryAttempt = (storage, releaseId, userId) => {
  try {
    storage?.removeItem?.(getUiSurfaceEntryAttemptKey(releaseId, userId));
  } catch (_error) {
    // A blocked storage API must never prevent the legacy page from loading.
  }
};
